module.exports = __webpack_public_path__ + "576a6e72a69871fd6b74650b381d14fb.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/competition-rules/rules_nl.pdf
// module id = 936
// module chunks = 1